export function normalizeSliderIndex({ currentIndex, maxIndex, minIndex = 0 }) {
  if (currentIndex >= minIndex && currentIndex <= maxIndex) {
    return currentIndex;
  }

  const maxDeltaIndex = maxIndex - minIndex + 1;

  if (currentIndex < minIndex) {
    const maxIndexOffset = (currentIndex - minIndex + 1) % maxDeltaIndex;

    return maxIndex + maxIndexOffset;
  }

  if (currentIndex > maxIndex) {
    const minIndexOffset = (currentIndex - maxIndex - 1) % maxDeltaIndex;

    return minIndex + minIndexOffset;
  }
}

export function calcSliderIndexesOfImagesToLoad({
  currentIndex,
  visibleSlidesCount,
  minIndex = 0,
  maxIndex,
  step = 1
}) {
  const visibleSlidesIndexes = [];

  for (
    let i = currentIndex - step;
    i < currentIndex + visibleSlidesCount + step;
    i++
  ) {
    visibleSlidesIndexes.push(
      normalizeSliderIndex({ currentIndex: i, minIndex, maxIndex })
    );
  }

  return visibleSlidesIndexes;
}
